import { configureStore } from '@reduxjs/toolkit'
import orderItemAmountReducer from './orderItemAmountSlice';
import orderInfoReducer from './orderInfoSlice';
import walletReducer from './walletSlice';
import saleTypeReducer from './saleTypeSlice';
import stockItemsStatsReducer from './stockItemsStatsSlice';
import configReducer from "./configSlice";
import sessionReducer from "./sessionSlice";

export const store = configureStore({
  reducer: {
    orderItemAmount: orderItemAmountReducer,
    orderInfo: orderInfoReducer,
    wallet: walletReducer,
    saleType: saleTypeReducer,
    stockItemsStats: stockItemsStatsReducer,
    config: configReducer,
    session: sessionReducer
  },
})
